import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { TranslocoRootModule } from 'src/app/transloco-root.module';
import { HttpClientModule } from '@angular/common/http';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ToastModule } from 'primeng/toast';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SharedModule } from '../../share/share.module';
import { ChatbotComponent } from './chatbot/chatbot.component';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { DashboardTemplateComponent } from '../dashboard/dashboard-template/dashboard-template.component';
import { FtcfCanvasComponent } from './ftcf-canvas/ftcf-canvas.component';
import { DatalogChartComponent } from './datalog-chart/datalog-chart.component';
import { DragRunCardComponent } from './drag-run-card/drag-run-card.component';
import { ChartArtifactComponent } from './chart-artifact/chart-artifact.component';
import { MapArtifactComponent } from './map-artifact/map-artifact.component';

@NgModule({
    declarations: [
        ChatbotComponent,
    ],
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        TranslocoRootModule,
        HttpClientModule,
        ButtonModule,
        ToastModule,
        ConfirmDialogModule,
        DialogModule,
        ProgressSpinnerModule,
        SharedModule,
        FormsModule,
        InputTextModule,
        InputTextareaModule,
        InputSwitchModule,
        DropdownModule,
        TooltipModule,
        DashboardTemplateComponent,
        FtcfCanvasComponent,
        DatalogChartComponent,
        DragRunCardComponent,
        ChartArtifactComponent,
        MapArtifactComponent,
    ],
    exports: [
        ChatbotComponent,
    ],
})
export class ChatbotModule {}
